// extracted by mini-css-extract-plugin
export default {"header":"SMLFormContainer_header__TZ6LB","title":"SMLFormContainer_title__ZRCjP","body":"SMLFormContainer_body__9Gurs","footer":"SMLFormContainer_footer__U6Hoj"};